import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    returnTo: String
  }

  click() {
    const returnTo = this.hasReturnToValue
      ? this.returnToValue
      : window.location.pathname + window.location.search

    window.location.href = returnTo
      ? `/login?return_to=${encodeURIComponent(returnTo)}`
      : "/login"
  }
}
